module.exports = "https://payment.pagoefectivo.pe/error-mobile.ef00c0b89127a5c067920fbd4aa170dd.png";